var app = angular.module("leonardo");

var OnDemandInstructionsDetail = function($scope, $window, $state, ngDialog, $stateParams, OnDemandInstructionService,
                                          FolderFileService, AttachmentService) {
  $scope.item = {};
  $scope.attachmentService = AttachmentService;

  OnDemandInstructionService.get($stateParams.pk).then(function(item) {
    $scope.item = item;
    $state.current.ncyBreadcrumbLabel = $scope.item.name;
    angular.forEach($scope.item.attachments, function(attachment){
      if (attachment.document_file){
        attachment.file = attachment.document_file.signed_view_url;
        attachment.folder_id = attachment.document_file.breadcrumb[attachment.document_file.breadcrumb.length - 1].id;
        attachment.breadcrumb_name = '';
        angular.forEach(attachment.document_file.breadcrumb, function(parent) {
          attachment.breadcrumb_name += parent.name + ' > ';
        });
        attachment.breadcrumb_name += attachment.name;
      }
      else if (attachment.link) {
        attachment.file = attachment.link;
      }
      else if (!attachment.name) {
        var array_url = attachment.file.split('/');
        attachment.name = array_url[array_url.length - 1];
      }
    });
  });

  $scope.openAttachmentDialog = function (attachments, index) {
    if (attachments[index].document_file) {
      $scope.getFileObject(attachments, index);
    }
    else if (attachments[index].link) {
      $window.open(attachments[index].link);
    }
    else {
      $scope.getFileObject(attachments, index);
    }
  };

  $scope.getFileObject = function (attachments, index) {
    if (attachments[index].document_file) {
      // Use authenticated method for document files
      FolderFileService.getFileObjectAuthenticated(attachments[index].document_file, function (fileObject) {
        var array_url = (fileObject && fileObject.type) ? fileObject.type.split('/') : [];
        if (_.contains(array_url, 'image')) {
          ngDialog.open({
            template: 'views/templates/dialog/attachment/list.html',
            controller: 'AttachmentListDialog',
            className: 'ngdialog-theme-default ngdialog-attachments-view',
            data: {
              attachments: attachments,
              index: index
            }
          });
        }
        else {
          // Use signed_view_url for secure inline viewing
          $window.open(attachments[index].document_file.signed_view_url || attachments[index].document_file.secure_share_url);
        }
      });
    }
    else {
      // For external links or non-document files, use the old method
      FolderFileService.getFileObject(attachments[index].file, function (fileObject) {
        var array_url = (fileObject && fileObject.type) ? fileObject.type.split('/') : [];
        if (_.contains(array_url, 'image')) {
          ngDialog.open({
            template: 'views/templates/dialog/attachment/list.html',
            controller: 'AttachmentListDialog',
            className: 'ngdialog-theme-default ngdialog-attachments-view',
            data: {
              attachments: attachments,
              index: index
            }
          });
        }
        else {
          // Use signed_view_url for secure inline viewing
          $window.open(attachments[index].signed_view_url || attachments[index].secure_share_url || attachments[index].file);
        }
      });
    }
  };
};

app.controller('OnDemandInstructionsDetail', ['$scope', '$window', '$state', 'ngDialog', '$stateParams',
  'OnDemandInstructionService', 'FolderFileService', 'AttachmentService', OnDemandInstructionsDetail]);
